import { render, staticRenderFns } from "./GnmNav.vue?vue&type=template&id=4ca5256f&scoped=true&"
import script from "./GnmNav.vue?vue&type=script&lang=js&"
export * from "./GnmNav.vue?vue&type=script&lang=js&"
import style0 from "./GnmNav.vue?vue&type=style&index=0&id=4ca5256f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5256f",
  null
  
)

export default component.exports